import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    ScreenSpaceEventType,
    Cartographic,
    Math as CesiumMath,
    Entity,
    defaultValue,
    defined
} from 'cesium'
import {
    ScreenSpaceEventHandler,
    ScreenSpaceEvent,
    useCesium,
} from 'resium'

import { actionCreators } from '@/duck/panel'
import { selectDrawPolygon, selectCurrentLayerGroup } from '@/selector'


const DrawRectangleControl = () => {
    const context = useCesium()
    const currentLayerGroup = useSelector(selectCurrentLayerGroup)
    const drawPolygon = useSelector(selectDrawPolygon)
    const dispatch = useDispatch()
    let isDrawing = currentLayerGroup === 'remote' && drawPolygon

    const draw = useCallback((e) => {
        const { scene, camera } = context
        const cartesian = camera.pickEllipsoid(e.position, scene.globe.ellipsoid)
        if (cartesian) {
            const cartographic = Cartographic.fromCartesian(cartesian)
            const longitudeString = CesiumMath.toDegrees(cartographic.longitude)
            const latitudeString = CesiumMath.toDegrees(cartographic.latitude)
            dispatch(actionCreators.panel.vertex.add({ position: [longitudeString, latitudeString] }))
        }
    }, [dispatch, context])

    const pick = useCallback((e) => {
        const { scene, camera } = context
        var picked = scene.pick(e.position)
        if (defined(picked)) {
            var id = defaultValue(picked.id, picked.primitive.id)
            if (id instanceof Entity) {
                const cartesian = camera.pickEllipsoid(e.position, scene.globe.ellipsoid)
                const cartographic = Cartographic.fromCartesian(cartesian)
                const lng = CesiumMath.toDegrees(cartographic.longitude)
                const lat = CesiumMath.toDegrees(cartographic.latitude)
                dispatch(actionCreators.panel.temperature.point({ lng: Math.floor(lng).toFixed(1), lat: Math.floor(lat).toFixed(1) }))
            }
        }
        return undefined;
    }, [dispatch, context])
    return (
        <ScreenSpaceEventHandler>
            {isDrawing &&
                <ScreenSpaceEvent action={(e) => draw(e)} type={ScreenSpaceEventType.LEFT_CLICK} />
            }
            {currentLayerGroup === 'route' &&
                <ScreenSpaceEvent action={(e) => pick(e)} type={ScreenSpaceEventType.LEFT_CLICK} />
            }
        </ScreenSpaceEventHandler>
    )
}

export default DrawRectangleControl